import Tooltip from "@kea-mod/common/tooltip";
import { useTranslation } from "react-i18next";
import type { Exercise } from "../../../types/Exercise";

type Props = {
  activeExercise: Exercise;
  h: Function;
};

export const FeedForwardPosField = (props: Props) => {
  const { t } = useTranslation();

  const onChange = (event: any) => {
    props.h(event);
  };

  return (
    <div className="field">
      <label className="label" htmlFor="feedForward_pos">
        {t("feedForward_pos")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("feedForward_pos_tooltip")}
        ></Tooltip>
      </label>
      <input
        type="text"
        className="input"
        id="feedForward_pos"
        name="feedForward_pos"
        value={props.activeExercise.feedForward_pos}
        onChange={onChange}
      />
    </div>
  );
};
